import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { CartStore } from '../../../stores/CartStore';
import { AddToListButton } from '../add-to-list-button';
import styles from './ActionButtonContainer.css';
import { AddToCartSection } from '../../../common/add-to-cart-section';
import { AlertZone } from '../../../common/alert-zone';
import { constants } from '../../../config';
import { InfoModal } from '../../../common/info-modal';

const IPropTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({
    ableToSell: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    isService: PropTypes.bool.isRequired,
    serviceMessage: PropTypes.string,
    serviceProduct: PropTypes.shape({
      id: PropTypes.string.isRequired,
      financing: PropTypes.shape({
        priceString: PropTypes.string.isRequired,
      }).isRequired,
    }),
    stockIsEmpty: PropTypes.func.isRequired,
    stockIsAlmostNone: PropTypes.func.isRequired,
    notAbleToSellString: PropTypes.string,
    inUse: PropTypes.bool,
  }).isRequired,
};

const defaultProps = {
  className: '',
};

const ActionButtonContainer = (props) => {
  // If the product is a service then the buttons to add to cart and list must not be shown
  // Instead a text must be shown that specifies why this product isn't on sale.
  if (props.product.isService) {
    return (
      <Fragment>
        <InfoModal
          id="servicio-instalación-covid"
          type="component"
          showConfirm={false}
          textCancel="Cerrar"
          showModal
        >
          <AlertZone
            show={constants.activeCovid}
            title=""
            subtitle="Medidas sanitarias durante la instalación"
          />
        </InfoModal>
        <div className={styles.greyBox}>
          {props.product.serviceMessage}
        </div>
      </Fragment>
    );
  }
  const productIsInFavorites = CartStore.productIsInFavorites(props.product.id);
  const disabledToAddCart = !props.product.ableToSell || props.product.stockIsEmpty() ||
    props.product.stockIsAlmostNone();
  return (
    <div className={props.className}>
      <AddToCartSection
        product={props.product}
        showText
      />
      <AddToListButton
        className={styles.addToListButton}
        disabled={productIsInFavorites}
        onClick={() => CartStore.addToFavorites(props.product)}
      />
      {
        !productIsInFavorites &&
        disabledToAddCart &&
          <p className={styles.genericSubtext}>
            Agrega este producto a tu lista para recibir
            una notificación cuando vuelva a estar disponible.
          </p>
      }
    </div>
  );
};

ActionButtonContainer.propTypes = IPropTypes;
ActionButtonContainer.defaultProps = defaultProps;

const ObservedActionButtonContainer = observer(ActionButtonContainer);

export { ObservedActionButtonContainer as ActionButtonContainer };



// WEBPACK FOOTER //
// ./src/pages/product-detail/action-button-container/ActionButtonContainer.jsx